import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, FileText, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export default function Boasvindas() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [nome, setNome] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (!user?.id) return;
      const { data } = await supabase
        .from('contratacao')
        .select('nome, cargo_id')
        .eq('id_usuario', user.id)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      if (data?.nome) setNome(String(data.nome).split(' ')[0]);
    })();
  }, [user?.id]);

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h1 className="text-3xl sm:text-4xl font-bold">
          Bem-vindo(a){nome ? `, ${nome}` : ''}!
        </h1>
        <p className="text-base text-muted-foreground">
          Vamos finalizar sua contratação em poucos passos.
        </p>
      </div>

      <Card>
        <CardContent className="p-5 space-y-3">
          <div className="flex items-start gap-3">
            <div className="h-9 w-9 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold">
              1
            </div>
            <div className="flex-1">
              <p className="font-medium">Envie seus documentos</p>
              <p className="text-sm text-muted-foreground">
                Tire fotos do RG, CPF e comprovantes pelo seu celular.
              </p>
            </div>
            <FileText className="h-5 w-5 text-muted-foreground mt-2" />
          </div>
          <div className="flex items-start gap-3">
            <div className="h-9 w-9 rounded-full bg-muted text-muted-foreground flex items-center justify-center font-semibold">
              2
            </div>
            <div className="flex-1">
              <p className="font-medium">Aguarde a validação</p>
              <p className="text-sm text-muted-foreground">
                Nosso RH vai conferir tudo e avisar você.
              </p>
            </div>
            <CheckCircle2 className="h-5 w-5 text-muted-foreground mt-2" />
          </div>
        </CardContent>
      </Card>

      <Button
        size="lg"
        className="w-full h-14 text-base"
        onClick={() => navigate('/candidato/documentos')}
      >
        Começar agora
        <ArrowRight className="h-5 w-5 ml-2" />
      </Button>
    </div>
  );
}
